import { fg } from '@atlaskit/platform-feature-flags/fg';

import type { Product } from '../types';

import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';

export function isEligibleForStandardToPremiumUpsell({
	product,
	edition,
	userRoles,
	trialOfferingName,
}: EditionAwarenessContextType): boolean {
	if (
		edition === 'standard' &&
		userRoles?.includes('SITE_ADMIN') &&
		trialOfferingName === 'premium'
	) {
		if (product === 'jira' && fg('edition_awareness_upsell_jira_fg')) {
			return true;
		}
		if (product === 'jira-service-management' && fg('edition_awareness_upsell_jsm_fg')) {
			return true;
		}
		if (product === 'confluence' && fg('edition_awareness_standard_upsell_confluence_ab_fg')) {
			return true;
		}
		if (product === 'jira-product-discovery' && fg('upsell_edition_awareness_jpd_fg')) {
			return true;
		}
	}

	return false;
}

const PRODUCT_TRAIT_ELIGIBILITY: Partial<Record<Product, keyof EditionAwarenessContextType>> = {
	jira: 'isEligibleForJswStandardToPremium',
	'jira-service-management': 'isEligibleForJsmStandardToPremium',
	'jira-product-discovery': 'isEligibleForJpdStandardToPremium',
	confluence: 'isEligibleForConfluenceStandardToPremium',
};

function getProductTraitEligibility(context: EditionAwarenessContextType): boolean {
	const traitKey = PRODUCT_TRAIT_ELIGIBILITY[context.product];
	return traitKey ? Boolean(context[traitKey]) : false;
}

export function isEligibleForStandardToPremium(context: EditionAwarenessContextType): boolean {
	const { edition, isInTrial, isInPredunning, userRoles, hasDismissedButton, onDismissButton } =
		context;

	return Boolean(
		isEditionOneOf(edition, ['standard']) &&
		// This trait will also check the supported products
		getProductTraitEligibility(context) &&
		userRoles?.includes('SITE_ADMIN') &&
		!isInTrial &&
		!isInPredunning &&
		hasDismissedButton === false &&
		typeof onDismissButton === 'function' &&
		fg('standard-to-premium-ea-refactor'),
	);
}
